import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=8c8bfa8e&scoped=true&"
import script from "./feedBack.vue?vue&type=script&lang=js&"
export * from "./feedBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8bfa8e",
  null
  
)

component.options.__file = "feedBack.vue"
export default component.exports